/**
 * Static class that holds the grant type constants.
 */
export class OAuth2Grant {
}
OAuth2Grant.PASSWORD = "password";
OAuth2Grant.REFRESH_TOKEN = "refresh_token";
